export const TRANSLATION_TYPE_OPTIONS = [
  { value: 'Available', label: 'Available' },
  { value: 'In Development – Licensee', label: 'In Development – Licensee' },
  { value: 'In Development – IHO', label: 'In Development – IHO' }
];

const LEGACY_TRANSLATION_TYPE_MAP = {
  Approved: 'Available',
  'In Development': 'In Development – IHO',
  'Awaiting Review': 'In Development – IHO',
  Rejected: 'In Development – IHO'
};

export function normalizeTranslationType(value) {
  if (!value) return 'In Development – IHO';
  if (TRANSLATION_TYPE_OPTIONS.some((o) => o.value === value)) return value;
  return LEGACY_TRANSLATION_TYPE_MAP[value] || 'In Development – IHO';
}

export function translationTypeBadgeClass(value) {
  const v = normalizeTranslationType(value);
  if (v === 'Available') return 'bg-green-100 text-green-800';
  if (v === 'In Development – Licensee') return 'bg-amber-100 text-amber-800';
  if (v === 'In Development – IHO') return 'bg-blue-100 text-blue-800';
  return 'bg-gray-100 text-gray-800';
}
